import { reactive } from 'vue'

// BOOKING DETAIL STORE
export const bookingDetailInitialState = {
  id: 335,
  status: 1,
  hour_stay: false,
  daily_price: null,
  num_of_guest: 1,
  num_of_night: 3,
  room_type_id: 108,
  arrive_date: '2024-01-18T00:00:00.000+00:00',
  depart_date: '2024-01-21T00:00:00.000+00:00',
  child_num: 1,
  u5_child_num: 1,
  room_id: 115,
  price_type: null,
  block_room: false,
  is_master: false,
  room_type_code: 'JS',
  room_num: 'JS-02',
  nett: false,
  currency_id: 5,
  currency_code: 'VND',
  exchange_rate: '11',
  no_extra_service: false,
  sub_booking_group_services: [],
  sub_booking_group_surcharges: [],
  booking_traveller: [
    {
      note: null,
      sex: 0,
      email: 'thom123@gmail.com',
      create_date: null,
      create_user_id: 0,
      modify_date: null,
      modify_user_id: 0,
      sub_booking_group_id: 0,
      traveller_id: 0,
      is_master: false,
      last_name: 'Lưu',
      first_name: 'Thơm',
      phone_number: '097 870 65 57',
      address_1: 'Yên Bái'
    }
  ],
  booking_group_id: null,
  booking_group_code: null,
  booker_name: '1 Lưu Thơm',
  source_group_code: '1',
  room_balance: null,
  room_charge: null,
  note: null
}

// {
//   "id": 0,
//   "booker": {
//       "id": 131,
//       "name": "string",
//       "phone": "string",
//       "email": "string",
//       "first_name": "string",
//       "last_name": null
//   },
//   "confirm_code": "string",
//   "depart_time": "test1053",
//   "vehicle": "test1053",
//   "license_plate": "test1053",
//   "arrival_time": "test1053",
//   "release_date": "2024-01-10",
//   "additional_info": {
//       "note": "string",
//       "agent_id": 62,
//       "sales_person_id": 68,
//       "debit_account_id": 2,
//       "no_price_printing": true,
//       "market_seg_id": 55,
//       "source_id": 140,
//       "pay_method": 7,
//       "commission_percent": null,
//       "commission_fee": null,
//       "group_code": null,
//       "credit_card": "credit_card",
//       "credit_card_owner": "credit_card_owner",
//       "expired_credit_card": "2025-08-08",
//       "room_booking_code": null,
//       "invoice_agent_name": "invoice_agent_name",
//       "invoice_address": "invoice_address",
//       "invoice_tax": "invoice_tax",
//       "invoice_phone": "invoice_phone",
//       "invoice_email": "invoice_email",
//       "special_command": "special_command",
//       "e_invoice": true,
//       "booking_status": 1
//   },
//   "create_date": null,
//   "create_user_id": 0,
//   "modify_date": null,
//   "modify_user_id": 0,
//   "sub_booking_group_services": [
//       {
//           "quantity": 2,
//           "note": "string",
//           "price": 100000,
//           "special_service_id": 5,
//           "special_service_code": "KFC",
//           "special_service_name": "Giao dịch ghi nhận doanh thu",
//           "sub_booking_group_id": 0,
//           "service_start_date": "2024-01-13T00:00:00.000+00:00",
//           "service_end_date": "2024-01-16T00:00:00.000+00:00",
//           "employee_id": 0,
//           "employee_name": null
//       }
//   ],
//   "booking_room": [
//       {
//           "id": 119,
//           "status": 2,
//           "hour_stay": false,
//           "daily_price": null,
//           "num_of_guest": 2,
//           "num_of_night": 1,
//           "room_type_id": 108,
//           "arrive_date": "2024-01-13T10:52:36.843+00:00",
//           "depart_date": "2024-01-16T10:52:36.843+00:00",
//           "child_num": 1,
//           "u5_child_num": 1,
//           "room_id": 109,
//           "price_type": null,
//           "block_room": true,
//           "is_master": false,
//           "room_type_code": "JS",
//           "room_num": "01",
//           "nett": false,
//           "currency_id": null,
//           "currency_code": null,
//           "exchange_rate": null,
//           "no_extra_service": false
//       }
//   ],
//   "booking_traveller": [
//       {
//           "note": "string",
//           "create_date": null,
//           "create_user_id": 0,
//           "modify_date": null,
//           "modify_user_id": 0,
//           "sub_booking_group_id": 119,
//           "traveller_id": 132,
//           "is_master": true
//       }
//   ],
//   "agent_name": "datnt10",
//   "room_type_code": null,
//   "room_num": null,
//   "market_seq_code": "a",
//   "source_group_code": "Duatest91",
//   "agent_name_2": null,
//   "booking_group_code": null,
//   "debit_account_num": "100015",
//   "breakfast_code": null,
//   "sales_person_name": null,
//   "discount_reason": null,
//   "percent_discount": null,
//   "amount_discount": null,
//   "room_balance": null
// }

export const bookingDetailStore = reactive({
  ...bookingDetailInitialState
})

export function resetBookingDetailStore() {
  Object.assign(bookingDetailStore, bookingDetailInitialState)
}

// END BOOKING DETAIL STORE

// SELECTED ROOM INFO STORE
export const roomInfoInitialState = {
  ooo: false,
  oos: false,
  id: null,
  sub_booking_group_id: null,
  room_id: null,
  room_num: null,
  room_x: 0,
  room_y: 0,
  width: null,
  height: null,
  room_level_name: null,
  from_date: null,
  to_date: null,
  from_date_next: null,
  to_date_next: null,
  room_status: null,
  booking_room_type: null,
  group_color: null,
  foc: false,
  arrive: true,
  depart: false,
  in_house: false,
  diff: false,
  empty_room: false,
  long_stay: false,
  short_stay: false,
  mission_warn_comment_mes: false,
  lock_transfer: false
}

export const roomInfo = reactive({ ...roomInfoInitialState })

// END SELECTED ROOM INFO STORE
